/* Program Finder — 5 step, fedele alla logica originale di Vale (vedi
   "Trova il tuo percorso.docx"), con due correzioni rispetto al documento:
   1) la regola di priorità "autonomia+autonomia" ora scatta SOLO se la
      persona non è già allenata (D5+D6 < 4) — prima ignorava il punteggio
      e mandava sul programma standard anche chi era molto esperta.
   2) infortuni o patologie dichiarate mandano SEMPRE a una call gratuita,
      scavalcando qualunque punteggio: prima di consigliare un programma in
      automatico, chi ha problemi di salute merita un confronto a voce.
   Il lead viene inviato a formsubmit.co; il risultato si vede comunque
   anche se l'invio del lead fallisce. */
(function () {
  'use strict';

function initFinder(root) {
  if (!root || root.dataset.finderReady === 'true') return;
  root.dataset.finderReady = 'true';

  var panel = root.querySelector('[data-finder-panel]');
  if (!panel) return;

  var configNode = root.querySelector('[data-finder-config]');
  var config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {
    config = {};
  }

  var STORAGE_KEY = 'strongher-program-finder';
  var TOTAL_STEPS = 5;

  var OPTIONS = {
    goal: [
      ['1|Iniziare ad allenarmi in modo più serio e strutturato e migliorare la mia forza', 'Forza', 'Palestra, carichi, progressione'],
      ['2|Iniziare a correre o migliorare nella corsa', 'Corsa', 'Tecnica, resistenza, distanza'],
      ['3|Preparare un obiettivo specifico (gara, evento, test)', 'Obiettivo specifico', 'Gara, evento o test']
    ],
    experience: [
      ['0|Non mi alleno / ho appena iniziato', 'Da zero', ''],
      ['0|Meno di 6 mesi', '< 6 mesi', ''],
      ['1|Da 6 mesi a 2 anni', '6 mesi — 2 anni', ''],
      ['2|Da 2 a 5 anni', '2 — 5 anni', ''],
      ['3|Più di 5 anni', '> 5 anni', '']
    ],
    structure: [
      ['0|Non seguo nessun programma, seguo un fai-da-me', 'Fai da me', ''],
      ['0|Seguo video o schede trovate online/su app', 'Video / app', ''],
      ['1|Ho una scheda generica della palestra', 'Scheda palestra', ''],
      ['2|Seguo (o ho seguito) una programmazione strutturata con progressioni', 'Programmazione', ''],
      ['3|Ho già lavorato con un coach in modo continuativo', 'Con un coach', '']
    ],
    technique: [
      ['0|Non li ho mai fatti / non li conosco bene', 'Non li conosco', ''],
      ['1|Li conosco ma non sono sicura della tecnica', 'Tecnica incerta', ''],
      ['2|Li eseguo con sicurezza e progredisco con i carichi', 'Sicura', '']
    ],
    distance: [
      ['0|Non corro ancora / meno di 5 km', '0 — 5 km', ''],
      ['1|5–15 km', '5 — 15 km', ''],
      ['2|15–30 km', '15 — 30 km', ''],
      ['3|Più di 30 km', '> 30 km', '']
    ],
    support: [
      ['0|Mi basta un programma ben fatto da seguire in autonomia', 'Autonomia', 'Un percorso ben fatto da seguire'],
      ['2|Vorrei un programma su misura con feedback e correzioni periodiche', 'Su misura', 'Programma personale e correzioni'],
      ['4|Voglio un rapporto continuativo con il coach basato sulla performance: revisioni tecniche, video-analisi, preparazione a una gara', 'Performance', 'Revisioni tecniche, video-analisi, gara']
    ],
    sessions: [
      ['0|1–2', '1 — 2', ''],
      ['1|2–3', '2 — 3', ''],
      ['2|4 o più', '4+', '']
    ],
    yesNo: [['No', 'No', ''], ['Sì', 'Sì', '']],
    format: [
      ['autonomia|Programma da seguire in autonomia', 'Autonomia', ''],
      ['coaching|Coaching mensile personalizzato', 'Coaching mensile', ''],
      ['boh|Non so, vorrei un consiglio', 'Non so', '']
    ]
  };

  var EQUIPMENT = ['Casa con manubri / attrezzatura limitata', 'Palestra completa'];

  var state = { step: 0, answers: {}, result: null, error: null, submitting: false };

  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) state.answers = JSON.parse(saved);
  } catch (error) {
    /* a corrupt draft is not worth blocking the quiz */
  }

  /* ------------------------------------------------------------- scoring */

  function key(value) {
    return typeof value === 'string' ? value.split('|')[0] : '';
  }
  function score(value) {
    return typeof value === 'string' ? Number(value.split('|')[0]) || 0 : 0;
  }
  function label(value) {
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'string') {
      var parts = value.split('|');
      return parts[parts.length - 1] || value;
    }
    return String(value == null ? '' : value);
  }

  function programResult(preferRunning) {
    return {
      title: preferRunning ? 'Get FastHer' : 'Get StrongHer',
      text: 'In base alle tue risposte, il punto di partenza ideale per te è ' +
        (preferRunning ? 'il programma di corsa' : 'Get StrongHer') +
        ': 12 settimane strutturate per costruire basi solide con il mio metodo. Se dopo il programma vorrai fare il salto al coaching personalizzato, avrai già il linguaggio e le fondamenta giuste.',
      cta: 'Scopri il programma',
      href: preferRunning ? config.runningUrl : config.strengthUrl
    };
  }
  function margheritaResult() {
    return {
      title: 'Coaching con Margherita',
      text: 'Hai già una base: quello che ti serve è una programmazione costruita su di te, con feedback e correzioni. Ti seguirà Margherita, coach del mio team che lavora con il mio metodo — sempre con presenza e supervisione mia sulla programmazione.',
      cta: 'Prenota con Margherita',
      href: config.margheritaUrl
    };
  }
  function valentinaResult() {
    return {
      title: 'Coaching con Valentina',
      text: 'Il tuo profilo e i tuoi obiettivi richiedono un lavoro su misura: ti scriverò personalmente via email per organizzare insieme il percorso.',
      cta: null,
      href: null
    };
  }
  function callResult(reason) {
    var text = 'Grazie per le tue risposte! Il tuo profilo merita qualche parola in più: ti scriverò via email nei prossimi giorni per capire insieme qual è la strada giusta per te.';
    if (reason === 'safety') {
      text = 'Grazie per le tue risposte, e per la fiducia nel condividermi informazioni sulla tua salute. Prima di consigliarti un percorso preferisco sentirti con calma: ti scriverò via email per parlarne insieme, in sicurezza.';
    }
    return {
      title: 'Facciamo due chiacchiere',
      text: text,
      cta: null,
      href: null
    };
  }

  /* Risultato fedele al documento originale di Vale, con 2 correzioni:
     - la regola di priorità "autonomia+autonomia" ora richiede anche
       D5+D6 < 4 (persona non ancora molto allenata);
     - infortuni/patologie dichiarati vincono su tutto il resto. */
  function getResult(answers) {
    var goal = key(answers.goal); // '1' forza, '2' corsa, '3' obiettivo specifico
    var isForzaQuestion = goal === '1' || goal === '3'; // mostra/conta D7 (tecnica)
    var isCorsaQuestion = goal === '2' || goal === '3'; // mostra/conta D8 (km)

    var total = score(answers.goal) + score(answers.experience) + score(answers.structure) + score(answers.support) + score(answers.sessions);
    if (isForzaQuestion) total += score(answers.technique);
    if (isCorsaQuestion) total += score(answers.distance);

    // Per l'obiettivo "specifico" (ambiguo tra forza e corsa), decidiamo quale
    // programma standard proporre in base a quale delle due domande pesa di più.
    var preferRunning = goal === '2' || (goal === '3' && score(answers.distance) > score(answers.technique));

    var expScore = score(answers.experience) + score(answers.structure);
    var candidate;

    // Regola di priorità di Vale: "la persona ti sta dicendo cosa vuole,
    // ascoltala" — ma solo se non è già una persona allenata (D5+D6 >= 4
    // vuol dire "molto allenata": va sempre a Margherita o Valentina).
    var wantsFullAutonomy = key(answers.support) === '0' && key(answers.format) === 'autonomia';
    if (wantsFullAutonomy && expScore < 4) {
      candidate = programResult(preferRunning);
    } else {
      // Fasce di punteggio: 0–6 programma, 7–8 zona grigia (ambiguo tra
      // programma e coaching), 9+ coaching. Dentro il coaching, chi ha
      // 5+ anni di esperienza va da Valentina, le altre da Margherita —
      // una volta chiaro che serve coaching, l'esperienza decide subito,
      // senza altre zone grigie.
      if (total <= 6) candidate = programResult(preferRunning);
      else if (total <= 8) candidate = callResult('grey');
      else candidate = (score(answers.experience) === 3) ? valentinaResult() : margheritaResult();
    }

    // Regola assoluta di Vale: chi è già molto allenata (D5+D6 >= 4) non
    // deve MAI finire sul programma standard, qualunque sia il resto del
    // punteggio — se il calcolo la porterebbe lì, la spostiamo su Margherita.
    if (expScore >= 4 && (candidate.title === 'Get StrongHer' || candidate.title === 'Get FastHer')) {
      candidate = margheritaResult();
    }

    // Get StrongHer è un programma da palestra: chi ha selezionato solo
    // "a casa con attrezzatura limitata" (senza palestra completa) non può
    // riceverlo — va su Margherita, che può adattare la programmazione.
    var hasGym = Array.isArray(answers.equipment) && answers.equipment.indexOf('Palestra completa') > -1;
    if (candidate.title === 'Get StrongHer' && !hasGym) {
      candidate = margheritaResult();
    }

    // Sicurezza: infortuni o patologie dichiarati non devono mai risultare in
    // un programma standard da seguire SENZA supervisione (Get StrongHer /
    // Get FastHer) — in quel caso deviamo su una call. Se invece l'esito è
    // già un coaching con una persona vera (Margherita o Valentina), la
    // lasciamo passare: la coach vedrà comunque i dettagli dichiarati nella
    // mail del lead e valuterà lei, senza bisogno di deviare tutto su una call.
    var hasHealthFlag = answers.injuries === 'Sì' || answers.conditions === 'Sì';
    if (hasHealthFlag && (candidate.title === 'Get StrongHer' || candidate.title === 'Get FastHer')) {
      candidate = callResult('safety');
    }

    return candidate;
  }

  /* -------------------------------------------------------------- markup */

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function requiredFields() {
    var goal = key(state.answers.goal);
    if (state.step === 0) return ['goal'];
    if (state.step === 1) {
      var fields = ['experience', 'structure'];
      if (goal === '1' || goal === '3') fields.push('technique');
      if (goal === '2' || goal === '3') fields.push('distance');
      return fields;
    }
    if (state.step === 2) return ['support', 'sessions'];
    if (state.step === 3) return ['injuries', 'conditions'];
    return ['equipment', 'format', 'name', 'email', 'age', 'consent'];
  }

  function isComplete() {
    return requiredFields().every(function (field) {
      var value = state.answers[field];
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'boolean') return value;
      return typeof value === 'string' && value.trim().length > 0;
    });
  }

  function options(name, list, compact) {
    var current = state.answers[name];
    return (
      '<div class="finder-options' +
      (compact ? ' finder-options--compact' : '') +
      '">' +
      list
        .map(function (option, index) {
          var value = option[0];
          var title = option[1];
          var description = option[2];
          return (
            '<label class="' +
            (current === value ? 'selected' : '') +
            '">' +
            '<input type="radio" name="' +
            name +
            '" value="' +
            escapeHtml(value) +
            '"' +
            (current === value ? ' checked' : '') +
            '>' +
            '<i>' +
            ('0' + (index + 1)).slice(-2) +
            '</i><span><strong>' +
            escapeHtml(title) +
            '</strong>' +
            (description ? '<em>' + escapeHtml(description) + '</em>' : '') +
            '</span></label>'
          );
        })
        .join('') +
      '</div>'
    );
  }

  function question(title, note, body) {
    return (
      '<fieldset class="finder-question"><legend>' +
      escapeHtml(title) +
      '</legend>' +
      (note ? '<p>' + escapeHtml(note) + '</p>' : '') +
      body +
      '</fieldset>'
    );
  }

  function detailField(name, ariaLabel, placeholder) {
    return (
      '<textarea data-detail="' +
      name +
      '" aria-label="' +
      escapeHtml(ariaLabel) +
      '" placeholder="' +
      escapeHtml(placeholder) +
      '">' +
      escapeHtml(state.answers[name] || '') +
      '</textarea>'
    );
  }

  function stepMarkup() {
    var goal = key(state.answers.goal);

    if (state.step === 0) {
      return question(
        'Qual è il tuo obiettivo principale?',
        'Scegli la direzione, non il risultato perfetto.',
        options('goal', OPTIONS.goal, false)
      );
    }

    if (state.step === 1) {
      var showTechnique = goal === '1' || goal === '3';
      var showDistance = goal === '2' || goal === '3';
      return (
        '<div class="finder-stack">' +
        question('Da quanto tempo ti alleni con costanza (almeno 2 volte a settimana)?', '', options('experience', OPTIONS.experience, true)) +
        question('Come ti alleni oggi?', '', options('structure', OPTIONS.structure, true)) +
        (showTechnique ? question('Come ti trovi con squat, stacco, panca o le loro varianti con manubri?', '', options('technique', OPTIONS.technique, true)) : '') +
        (showDistance ? question('Quanti km corri in una settimana tipica?', '', options('distance', OPTIONS.distance, true)) : '') +
        '</div>'
      );
    }

    if (state.step === 2) {
      return (
        '<div class="finder-stack">' +
        question('Che tipo di accompagnamento cerchi?', '', options('support', OPTIONS.support, false)) +
        question('Quante sessioni a settimana riesci realisticamente a dedicare all\'allenamento?', '', options('sessions', OPTIONS.sessions, true)) +
        '</div>'
      );
    }

    if (state.step === 3) {
      return (
        '<div class="finder-stack">' +
        question(
          'Hai infortuni attuali o passati rilevanti?',
          '',
          options('injuries', OPTIONS.yesNo, true) +
            (state.answers.injuries === 'Sì'
              ? detailField('injuryDetails', 'Dettagli sugli infortuni', 'Raccontaci solo ciò che è utile sapere')
              : '')
        ) +
        question(
          "Hai patologie, condizioni mediche o assumi farmaci che possono influire sull'attività fisica?",
          '',
          options('conditions', OPTIONS.yesNo, true) +
            (state.answers.conditions === 'Sì'
              ? detailField('conditionDetails', 'Dettagli sulle condizioni mediche', 'Indica le informazioni essenziali')
              : '')
        ) +
        '</div>'
      );
    }

    var equipment = Array.isArray(state.answers.equipment) ? state.answers.equipment : [];
    return (
      '<div class="finder-stack">' +
      question(
        'Dove ti alleni e con quale attrezzatura?',
        '',
        '<div class="checkbox-options">' +
          EQUIPMENT.map(function (item) {
            return (
              '<label class="' +
              (equipment.indexOf(item) > -1 ? 'selected' : '') +
              '"><input type="checkbox" data-equipment value="' +
              escapeHtml(item) +
              '"' +
              (equipment.indexOf(item) > -1 ? ' checked' : '') +
              '><span>' +
              escapeHtml(item) +
              '</span></label>'
            );
          }).join('') +
          '</div>'
      ) +
      question('Quale formato preferisci?', '', options('format', OPTIONS.format, true)) +
      '<div class="finder-fields">' +
      '<label><span>Nome e cognome</span><input data-field="name" autocomplete="name" value="' +
      escapeHtml(state.answers.name || '') +
      '"></label>' +
      '<label><span>Email</span><input data-field="email" type="email" autocomplete="email" value="' +
      escapeHtml(state.answers.email || '') +
      '"></label>' +
      '<label><span>Età</span><input data-field="age" type="number" min="16" max="99" value="' +
      escapeHtml(state.answers.age || '') +
      '"></label>' +
      '</div>' +
      '<label class="consent"><input type="checkbox" data-consent' +
      (state.answers.consent === true ? ' checked' : '') +
      '><span>' +
      config.consentText +
      '</span></label>' +
      '</div>'
    );
  }

  function render() {
    if (state.result) {
      panel.innerHTML =
        '<div class="finder-result" role="status">' +
        '<p class="eyebrow">Il tuo risultato</p>' +
        '<span class="finder-result__number">01</span>' +
        '<h3>' +
        escapeHtml(state.result.title) +
        '</h3>' +
        '<p>' +
        escapeHtml(state.result.text) +
        '</p>' +
        (state.result.href
          ? '<a class="button button--solid" href="' +
            escapeHtml(state.result.href) +
            '">' +
            escapeHtml(state.result.cta) +
            ' <span aria-hidden="true">↗</span></a>'
          : '<p class="finder-result__followup">📩 Controlla la tua email: ti scriverò a breve.</p>') +
        '<button class="text-button" type="button" data-restart>Ricomincia</button>' +
        '</div>';
      return;
    }

    var progress = ((state.step + 1) / TOTAL_STEPS) * 100;

    panel.innerHTML =
      '<form novalidate>' +
      '<div class="finder-progress" aria-label="Passaggio ' +
      (state.step + 1) +
      ' di ' +
      TOTAL_STEPS +
      '"><span>0' +
      (state.step + 1) +
      '</span><div><i style="width:' +
      progress +
      '%"></i></div><em>0' +
      TOTAL_STEPS +
      '</em></div>' +
      stepMarkup() +
      (state.error ? '<p class="form-error" role="alert">' + escapeHtml(state.error) + '</p>' : '') +
      '<div class="finder-controls">' +
      (state.step > 0 ? '<button class="text-button" type="button" data-back>← Indietro</button>' : '<span></span>') +
      (state.step < TOTAL_STEPS - 1
        ? '<button class="button button--solid" type="button" data-next>Continua <span aria-hidden="true">→</span></button>'
        : '<button class="button button--solid" type="submit"' +
          (state.submitting ? ' disabled' : '') +
          '>' +
          (state.submitting ? 'Calcolo…' : 'Vedi il risultato →') +
          '</button>') +
      '</div>' +
      '</form>';
  }

  /* -------------------------------------------------------------- events */

  function persist() {
    try {
      if (Object.keys(state.answers).length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state.answers));
    } catch (error) {
      /* private browsing — the quiz still works, it just will not resume */
    }
  }

  function setAnswer(name, value) {
    state.answers[name] = value;
    state.error = null;
    persist();
  }

  function track(event, payload) {
    if (typeof window.StrongHerTrack === 'function') window.StrongHerTrack(event, payload);
  }

  panel.addEventListener('change', function (event) {
    var target = event.target;

    if (target.matches('input[type="radio"][name]')) {
      setAnswer(target.name, target.value);
      render();
      return;
    }
    if (target.hasAttribute('data-equipment')) {
      var current = Array.isArray(state.answers.equipment) ? state.answers.equipment.slice() : [];
      var index = current.indexOf(target.value);
      if (index > -1) {
        current.splice(index, 1);
      } else {
        current.push(target.value);
      }
      setAnswer('equipment', current);
      render();
      return;
    }
    if (target.hasAttribute('data-consent')) {
      setAnswer('consent', target.checked);
    }
  });

  panel.addEventListener('input', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-field')) {
      state.answers[target.getAttribute('data-field')] = target.value;
      persist();
    }
    if (target.hasAttribute('data-detail')) {
      state.answers[target.getAttribute('data-detail')] = target.value;
      persist();
    }
  });

  panel.addEventListener('click', function (event) {
    if (event.target.closest('[data-next]')) {
      if (!isComplete()) {
        state.error = 'Completa le risposte richieste per continuare.';
        render();
        return;
      }
      if (state.step === 0) track('quiz_start', { goal: label(state.answers.goal) });
      state.step = Math.min(state.step + 1, TOTAL_STEPS - 1);
      state.error = null;
      track('quiz_step', { step: state.step + 1 });
      render();
      return;
    }

    if (event.target.closest('[data-back]')) {
      state.step = Math.max(0, state.step - 1);
      state.error = null;
      render();
      return;
    }

    if (event.target.closest('[data-restart]')) {
      state = { step: 0, answers: {}, result: null, error: null, submitting: false };
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        /* nothing to clear */
      }
      render();
    }
  });

  panel.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!isComplete()) {
      state.error = 'Completa i dati e accetta la privacy policy per vedere il risultato.';
      render();
      return;
    }

    state.submitting = true;
    render();

    var result = getResult(state.answers);
    var payload = { _subject: 'StrongHer Finder · ' + result.title, _template: 'table', consenso: 'Sì' };
    Object.keys(state.answers).forEach(function (name) {
      if (name === 'consent') return;
      payload[name] = label(state.answers[name]);
    });
    payload.result = result.title;

    // Note interne per Vale/Margherita (non cambiano l'esito mostrato alla
    // cliente, si sommano se più di una si applica):
    var notes = [];
    if (score(state.answers.sessions) === 0 && (result.title === 'Coaching con Margherita' || result.title === 'Coaching con Valentina')) {
      notes.push('Sessioni disponibili: 1-2/settimana con esito coaching — valuta se proporre prima il programma 3 mesi.');
    }
    if ((state.answers.injuries === 'Sì' || state.answers.conditions === 'Sì') && (result.title === 'Coaching con Margherita' || result.title === 'Coaching con Valentina')) {
      notes.push('Ha dichiarato infortuni/patologie (Sì) — controlla i dettagli prima di impostare la programmazione.');
    }
    if (notes.length) payload.nota_interna = notes.join(' | ');

    // Il lead va all'email di default per tutti gli esiti, TRANNE "Coaching
    // con Margherita": in quel caso, se è configurata un'email dedicata per
    // lei, il lead va SOLO a lei (non a Vale).
    var endpoint = (result.title === 'Coaching con Margherita' && config.margheritaLeadEndpoint)
      ? config.margheritaLeadEndpoint
      : config.leadEndpoint;

    var request = endpoint
      ? fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
      : Promise.resolve();

    request
      .catch(function () {
        /* The recommendation is useful even when the lead service is down. */
      })
      .then(function () {
        state.submitting = false;
        state.result = result;
        render();
        track('quiz_complete', { result: result.title, goal: label(state.answers.goal) });
      });
  });

  render();
}

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-finder]'), initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', function (event) {
    var finder = event.target.querySelector('[data-finder]');
    if (finder) {
      finder.dataset.finderReady = 'false';
      initFinder(finder);
    }
  });
})();